module.exports = __webpack_public_path__ + "img/grid.f0f65e43.svg";